












































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Product from "../../../store/entities/product";
import AppConsts from "../../../lib/appconst";
import _ from "lodash";
@Component
export default class CreateUser extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  product: Product = new Product();
  isUpload: boolean = false;
  imageUrl: string = "";
  spinShow: boolean = false;
  isShowLengthOfSerial: boolean = true;
  dataChildProducts = [];
  loading: boolean = false;
  clients: [] = [];
  selectChildClientCode: string = "";
  categoriesOfClient: [] = [];
  selectChildCategoryId: number = 0;
  unitsOfClient: [] = [];
  selectChildUnitId: number = 0;
  serviceProductType = AppConsts.productTypes.service;
  get units() {
    return this.$store.state.unit.unitsForSelect;
  }
  get categories() {
    let re = this.$store.state.category.categoriesForSelect;
    return _.filter(re, (x) => {
      return x.clientCode == null;
    });
  }
  get storageTypes() {
    return this.$store.state.product.storageTypes;
  }
  get inventModels() {
    return this.$store.state.product.inventModels;
  }
  get types() {
    return this.$store.state.product.types;
  }
  get productTypes() {
    return this.$store.state.product.productTypes;
  }
  get brands() {
    return this.$store.state.masterData.brands;
  }
  isClient() {
    return !_.isNil(this.$store.state.session.client);
  }
  isTenant() {
    return !_.isNil(this.$store.state.session.tenant);
  }
  changeProductType() {
    if (this.product.productType === AppConsts.productTypes.service) {
      this.product.isAccessories = false;
      this.product.type = AppConsts.productServiceDefaultValues.type;
      this.product.storageType =
        AppConsts.productServiceDefaultValues.storageType;
      this.product.inventModel =
        AppConsts.productServiceDefaultValues.inventModel;
    }
  }
  save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreateProduct"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          if (this.isClient()) {
            await this.$store.dispatch({
              type: "product/create",
              data: this.product,
            });
          } else {
            this.product.items = this.dataChildProducts;
            await this.$store.dispatch({
              type: "product/createMaster",
              data: this.product,
            });
          }

          Util.showSuccessMsg(this, "Success.CreateProduct");
          this.$emit("save-success");
          this.onGoBack();
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  onGoBack() {
    (this.$refs.productForm as any).resetFields();
    this.$emit("input", false);
    this.$root.$router.push({ name: "product" });
  }
  onChangeStorageType() {
    if (this.product.storageType == AppConsts.storageType.serial) {
      this.isShowLengthOfSerial = true;
    } else {
      this.isShowLengthOfSerial = false;
    }
  }
  validatorSku = (rule: any, value: any, callback: any) => {
    if (_.isNil(value) || _.isEmpty(value)) {
      callback();
    } else {
      if (Util.isProductSkuFormat(value)) {
        callback(new Error(this.L("Error.MatchedProductSkuFormat", undefined)));
      } else {
        callback();
      }
    }
  };
  validatorExternalCode = (rule: any, value: any, callback: any) => {
    if (_.isNil(value) || _.isEmpty(value)) {
      callback();
    } else {
      if (Util.isProductSkuFormat(value)) {
        callback(
          new Error(this.L("Error.MatchedProductExternalFormat", undefined))
        );
      } else {
        callback();
      }
    }
  };
  productRule = {
    sku: [{ validator: this.validatorSku }],
    productType: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Type")),
        trigger: "blur",
      },
    ],
    unitId: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Unit")),
        trigger: "blur",
      },
    ],
    categoryId: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Category")),
        trigger: "blur",
      },
    ],
    brandId: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("BrandName")),
        trigger: "blur",
      },
    ],
    inventModel: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("InventModel")
        ),
        trigger: "blur",
      },
    ],
    storageType: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("StorageType")
        ),
        trigger: "blur",
      },
    ],
    type: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ProductType")
        ),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    externalCode: [
      {
        validator: this.validatorExternalCode,
      },
    ],
    tax: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Tax")),
        trigger: "blur",
      },
    ],
  };

  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (
      fileExt === "jpep" ||
      fileExt === "jpg" ||
      fileExt === "png" ||
      fileExt === "gif" ||
      fileExt === "jfif"
    ) {
      let data = new FormData();
      data.append("file", file);

      this.$store.dispatch("product/uploadProductImage", data).then((res) => {
        this.product.thumbnailUrl = res;
        this.imageUrl = Util.getAppUrlImage(res);
        this.isUpload = true;
      });
    }

    return false;
  }
  handleRemoveAvatar() {
    this.isUpload = false;
    this.imageUrl = "";
    this.product.thumbnailUrl = "";
  }
  childProductColumns = [
    {
      title: Util.L("Order"),
      width: 50,
      key: "orderNo",
    },
    {
      title: Util.L("Client"),
      key: "clientName",
    },
    {
      title: Util.L("Category"),
      key: "categoryName",
    },
    {
      title: Util.L("Unit"),
      key: "unitName",
    },
    {
      title: Util.L("Action"),
      slot: "actionChildProduct",
    },
  ];

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: false },
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        this.clients = re;
        this.selectChildClientCode = re[0].code;
        this.changeClientCode();
      });
  }

  async changeClientCode() {
    await this.getCategoriesOfClientForSelect();
    await this.getUnitsOfClientForSelect();
  }

  async getCategoriesOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: { clientCode: this.selectChildClientCode },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        this.categoriesOfClient = re;
        this.selectChildCategoryId = 0;
      });
  }

  async getUnitsOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "unit/getUnitsOfClientForSelect",
        data: { clientCode: this.selectChildClientCode },
      })
      .then(() => {
        var re = this.$store.state.unit.unitsOfClientForSelect;
        this.unitsOfClient = re;
        this.selectChildUnitId = 0;
      });
  }

  addChildProduct() {
    var indexNewChild = _.findIndex(this.dataChildProducts, [
      "clientCode",
      this.selectChildClientCode,
    ]);
    if (indexNewChild > -1) {
      Util.showNoticeErrorMsg(this, Util.L("ClientExistedInList"));
      return;
    }

    const item = {
      id: 0,
      clientCode: this.selectChildClientCode,
      clientName: _.result(
        _.find(this.clients, ["code", this.selectChildClientCode]),
        "displayName"
      ),
      categoryId: this.selectChildCategoryId,
      categoryName: _.result(
        _.find(this.categoriesOfClient, ["id", this.selectChildCategoryId]),
        "displayName"
      ),
      unitId: this.selectChildUnitId,
      unitName: _.result(
        _.find(this.unitsOfClient, ["id", this.selectChildUnitId]),
        "displayName"
      ),
    };
    this.dataChildProducts.push(item);
    this.reorderDataChildProducts();
  }

  removeChildProduct(row, index) {
    this.dataChildProducts.splice(index, 1);
    this.reorderDataChildProducts();
  }

  reorderDataChildProducts() {
    let index = 0;
    this.dataChildProducts.forEach(function (item) {
      item.orderNo = index + 1;
      index++;
    });
  }

  async created() {
    this.spinShow = true;
    try {
      await this.$store.dispatch({
        type: "product/getListStorageTypesForSelect",
      });
      await this.$store.dispatch({
        type: "product/getListInventModelsForSelect",
      });
      await this.$store.dispatch({
        type: "product/getListTypesForSelect",
      });
      await this.$store.dispatch({
        type: "product/getListProductTypesForSelect",
      });
      await this.$store.dispatch({
        type: "unit/getListForSelect",
      });
      await this.$store.dispatch({
        type: "category/getListForSelect",
      });
      await this.$store.dispatch({
        type: "masterData/getBrands",
      });
      if (!this.isTenant() && !this.isClient()) {
        await this.getClients();
      }
      this.isShowLengthOfSerial = false;
      this.imageUrl = "";
      this.product.tax = 10;
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
